module.exports = __webpack_public_path__ + "img/pr-1.6452a612.png";